export default __webpack_public_path__ + "static/media/check-mark-circle-icon.57d3b0cb.webp";